import { render, staticRenderFns } from "./HeaderBtns.vue?vue&type=template&id=0baa7f7b&"
import script from "./HeaderBtns.vue?vue&type=script&lang=js&"
export * from "./HeaderBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports